import { Moment } from 'moment';
import { ICurrencies, ICurrencyDTO } from './currencies.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface IBankInfo {
    accountNumber?: string;
    bicCode?: string;
    holderName?: string;
    id?: number;
    isPrimaryAccount?: boolean;
    currency?: number;
    currencyCode?: string;
    currencyDTO?: ICurrencies;
}

export class BankInfo implements IBankInfo {
    constructor(
        public accountNumber?: string,
        public bicCode?: string,
        public holderName?: string,
        public id?: number,
        public isPrimaryAccount?: boolean,
        public currency?: number,
        public currencyCode?: string,
        public currencyDTO?: ICurrencies
    ) {
        this.isPrimaryAccount = false;
    }
}

export interface IBankInfoDTO {
    id?: number;
    holderName?: string;
    accountNumber?: string;
    bicCode?: string;
    currency?: number;
    currencyCode?: string;
    currencyDTO?: ICurrencyDTO;
    isPrimaryAccount?: boolean;
}

export class BankInfoDTO implements IBankInfoDTO {
    constructor(
        public id?: number,
        public holderName?: string,
        public accountNumber?: string,
        public bicCode?: string,
        public currency?: number,
        public currencyCode?: string,
        public currencyDTO?: ICurrencyDTO,
        public isPrimaryAccount?: boolean,
    ) {
        this.isPrimaryAccount = false;
    }
}
